export const ViewAsEndpoints = {
  get: (membershipSlug: string, productId: string) =>
    `/rest/v1/admin/memberships/${membershipSlug}/products/${productId}/classes/preview`
}
